import { useEffect } from 'react';
import { onSnapshot, query, where } from 'firebase/firestore';
import { Channel } from '../../type';
import {
  useChannelCollection,
  useCurrentUserGuid,
} from '../../../../firebase/useCollection';
import { useUserFetcherForChannels } from './useUserFetcher';
import { useCareTeam } from '../store/useCareTeam';

export const useChannelListener = (): void => {
  const userGuid = useCurrentUserGuid();
  const collection = useChannelCollection();
  const [, dispatch] = useCareTeam();
  const fetchUsers = useUserFetcherForChannels();
  useEffect(() => {
    console.debug('Going to start listener on channels');
    const channelQuery = query(
      collection,
      where('type', 'in', [
        'CARE_TEAM',
        'CARE_TEAM_ES_NORCAL',
        'SCHEDULING_TEAM',
        'PEER_TO_PEER',
      ]),
      where('_memberGuids', 'array-contains', userGuid),
    );
    const unsubscribe = onSnapshot(channelQuery, async (snapshot) => {
      const channels = snapshot
        .docChanges()
        .map((docChange) => docChange.doc.data() as Channel);
      const users = await fetchUsers(channels);
      dispatch({ type: 'CHANNEL_UPDATE', channels, users });
    });
    return () => {
      console.debug('Going to cancel listener on channels');
      unsubscribe();
    };
  }, [userGuid, collection, dispatch, fetchUsers]);
};
